const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, unknown>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as { default?: Record<string, unknown>; common?: Record<string, unknown> };

    if (!messages[lang]) {
      messages[lang] = {};
    }

    const ns = namespace || 'common';

    if (module.default) {
      messages[lang][ns] = module.default;
    } else if (module.common) {
      messages[lang][ns] = module.common;
    }
  }
});

// Flatten all namespaces into translation so keys like t("hero.h1") work directly
const i18nMessages: Record<string, { translation: Record<string, unknown> }> = {};
Object.keys(messages).forEach((lang) => {
  const flattened: Record<string, unknown> = {};
  Object.keys(messages[lang]).forEach((ns) => {
    Object.assign(flattened, messages[lang][ns]);
  });
  i18nMessages[lang] = { translation: flattened };
});

export default i18nMessages;